import { render, staticRenderFns } from "./retailindex.vue?vue&type=template&id=6995d6e8&scoped=true"
import script from "./retailindex.vue?vue&type=script&lang=js"
export * from "./retailindex.vue?vue&type=script&lang=js"
import style0 from "./retailindex.vue?vue&type=style&index=0&id=6995d6e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6995d6e8",
  null
  
)

export default component.exports